import React, { PropsWithChildren, ReactNode } from "react";
import styled from "styled-components";
import { getNewLookTokens, newLookType } from "common/NewLook/tokens.ts";

interface SettingsRowLabelProps {
  /** A service's own mark (Telegram, Discord); no decorative icons. */
  icon?: ReactNode;
}

/**
 * The name of an item row in a settings panel (new look): ink, medium weight,
 * with the service's mark inline when it identifies the item.
 */
const SettingsRowLabel = ({
  icon,
  children,
}: PropsWithChildren<SettingsRowLabelProps>) => (
  <Label>
    {icon && <Mark>{icon}</Mark>}
    <Text>{children}</Text>
  </Label>
);

export default SettingsRowLabel;

const Label = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  ${newLookType.body};
  font-weight: 500;
  color: ${(p) => getNewLookTokens(p.theme).ink};
`;
const Text = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const Mark = styled.span`
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: ${(p) => getNewLookTokens(p.theme).secondary};
  svg {
    width: 16px;
    height: 16px;
  }
  svg:not([stroke]) path {
    fill: ${(p) => getNewLookTokens(p.theme).secondary};
  }
`;
